import sc from 'web/components/styled';
import formError from './formError.css';

const FormError = sc.div(formError);
FormError.displayName = 'FormError';

export default FormError;
